import { DataService } from './../../services/data.service';
import { IntroModalComponent } from './../intro-modal/intro-modal.component';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { LoaderService } from '../../services/loader/loader.service';


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  isReferalCodeVerified = false;
  isprofileCompleted = false;
  errMessage = 'This field shouldn\'t be empty *';
  mailError = 'Please enter a valid email ID'
  submitted = false;
  referalsubmitted = false;

  referalVerifiedDetails = {};
  profileDetails = {};

  strReferalCode = '';
  strUsername = '';
  strUserEmail = '';
  strUserPassword = '';
  strUserConfirmPassword = '';

  completeProfileForm = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(30)]],
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]],
    password: ['', [Validators.required, Validators.maxLength(10)]],
    confirmpass: ['', [Validators.required, Validators.maxLength(10)]],
    // estimated_hours: [''],
    // deadline: ['', Validators.required],
    // reward: ['', [Validators.required, Validators.max(170)]],
    // address: ['', Validators.required],
    // instruction_manual: ['', Validators.required]
  });

  referalForm = this.fb.group({
    referalcode: ['', [Validators.required]],

  });

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<SignupComponent>,
    public router: Router,
    // private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data, private fb: FormBuilder, public _dataService: DataService, public loaderService: LoaderService) { }

  ngOnInit(): void {
  }
  get fcontrol() { return this.completeProfileForm.controls; };

  get referalfcontrol() { return this.referalForm.controls; }

  validateReferalCode() {
    this.referalsubmitted = true;

    //  console.log(this.strUserPassword,this.strUserConfirmPassword,'kjljlkj');
    this.referalForm.markAllAsTouched();

    if (this.referalForm.status === 'VALID') {


      // this.isReferalCodeVerified  = true;

      this.loaderService.display(true);
      this._dataService.validateReferal(this.strReferalCode).subscribe((resp: any) => {

        if (resp.success) {
          this.referalVerifiedDetails = resp.data;
          this.isReferalCodeVerified = true;
          this.loaderService.display(false);
        }


      }, Error => {
        this.loaderService.display(false);
        console.log('Err is ', Error);
        this.referalForm.controls['referalcode'].setErrors({ 'incorrect': true });

      });

    }



  }

  close() {
    this.dialogRef.close();
  }

  continueCompleteProfile() {
    this.submitted = true;

    let postData = {};
    if ((this.completeProfileForm.status === 'VALID') && (this.strUserPassword == this.strUserConfirmPassword)) {

      this.loaderService.display(true);
      postData['group'] = this.referalVerifiedDetails['id'];
      postData['name'] = this.strUsername;
      postData['password'] = this.strUserPassword;
      if (this.strUserEmail != '') {
        postData['email'] = this.strUserEmail;
      }

      this._dataService.signUP(postData).subscribe((resp: any) => {

        if (resp.success) {
          this.profileDetails = resp.data;
          this.isprofileCompleted = true;
          this.loaderService.display(false);
          this.saveData(this.profileDetails);

        }


      }, Error => {
        this.loaderService.display(true);
        console.log('Err is ', Error);

      });

    }


  }

  profileCreated() {
    this.dialogRef.close('success');
  }

  saveData(data) {
    localStorage.setItem('isUserLoggedin', 'true');
    localStorage.setItem('userData', JSON.stringify(data));

  }

  // goto login window
  gotoLogin() {
    this.dialogRef.close('login');
  }

  gotoVideos() {
    this.dialogRef.close('videos');
  }


}
